<template>
  <v-content v-if="loggedin">
    <v-container fluid>
      <Header :title="'Dashboard'" />
      <Tutor :buttonName="'Book a Tutor'" v-if="has_tutor_products"/>

      <v-row v-if='Object.keys(currentUser).length !=0  && (currentUser.roles.includes(1) || currentUser.roles.includes(3))'>
        <v-col cols='12' md='3' sm='12'>
          <v-autocomplete
              v-model="selectedGroups"
              :items="groups"
              item-value="group_id"
              item-text="group_name"
              :label="'Groups' | translate"
              outlined
              autocomplete="off"
              chips
              small-chips
              multiple
              required
              :no-data-text="$t('No data available')"
              @change="changedGroup"
            >
            <template v-slot:prepend-item>
              <v-list-item>
                <v-checkbox @change="checkboxUpdated('groups')" v-model="checkAllGroups" label="All"></v-checkbox>
              </v-list-item>
            </template>  
            </v-autocomplete>
        </v-col> 
        <v-col cols='12' md='3' sm='12'>
          <v-autocomplete
              v-model="selectedCourses"
              :items="courses"
              item-value="course_id"
              item-text="course_name"
              :label="'Courses' | translate"
              outlined
              autocomplete="off"
              chips
              small-chips
              multiple
              required
              :no-data-text="$t('No data available')"
              :disabled="(ischangeGroupApi? true : false)"
            >
          <template v-slot:prepend-item>
            <v-list-item>
                <v-checkbox @change="checkboxUpdated('courses')" v-model="checkAllCourses" label="All"></v-checkbox>
            </v-list-item>
          </template>              
            
            </v-autocomplete>
        </v-col>
        <v-col cols='12' md='3' sm='12'>
          <v-autocomplete
              v-model="selectedUsers"
              :items="users"
              item-value="user_id"
              :item-text="item =>`${item.name} (${item.email})`"
              :label="'Users' | translate"
              outlined
              autocomplete="off"
              chips
              small-chips
              multiple
              required
              :no-data-text="$t('No data available')"
              :disabled="(ischangeGroupApi? true : false)"
            >
          <template v-slot:prepend-item>
            <v-list-item>
              <v-checkbox @change="checkboxUpdated('users')" v-model="checkAllUsers" label="All"></v-checkbox>
            </v-list-item>
          </template>            
            
            </v-autocomplete>
        </v-col>        
        <v-col cols='12' md='3' sm='12'>
          <v-row class="mt-n3">
            <v-col cols="12" md="6" sm="12">
              <v-btn :disabled="(ischangeGroupApi? true : false)" class="white--text" small :color="primary_color" @click="getDashboardData()"  x-large block>
                {{ 'Search' | translate }}
              </v-btn>
            </v-col>
            <v-col cols="12" md="6" sm="12">
              <v-btn :disabled="(ischangeGroupApi? true : false)" class="white--text" small :color="primary_color" @click="clearFilter()"  x-large block>
                {{ 'Reset' | translate }}
              </v-btn>
            </v-col>
          </v-row>
             
        </v-col>
      </v-row>  

      <template v-if="adminSearch">
          <v-dialog v-model="adminSearch" persistent fullscreen content-class="loading-dialog">
            <v-container fill-height>
              <v-layout row justify-center align-center>
                <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
              </v-layout>
            </v-container>
          </v-dialog>
      </template>
      <template v-else-if="!adminSearch">
      <v-row v-if="isSearching && Object.keys(dashboardstats).length >0" class="mt-n3 mb-2">
        <v-col cols="12" md="7">
          <h3>
            {{$t('dashboardstats', {users:dashboardstats.tot_users, userstat:(dashboardstats.tot_users == 1 ? (curLanguage.lang_code == 'de' ? ' Nutzer' : 'user' ) : (curLanguage.lang_code == 'de' ? 'Nutzer' : 'users' )),courses: dashboardstats.tot_courses, coursesstat: (dashboardstats.tot_courses == 1 ? (curLanguage.lang_code == 'de' ? 'Kurs' : 'course' ) : (curLanguage.lang_code == 'de' ? 'Kurse' : 'courses' )) }) }}
          </h3>
        </v-col>
        <v-col cols="12" md="3" class="text-right">
          <h3>{{ 'Subscribed' | translate }} {{ ':'+dashboardstats.subscribed_percent+'%'}} </h3>
        </v-col>
        <v-col cols="12" md="2" class="text-right">
          <h3>{{ 'Passed' | translate }}{{ ':'+dashboardstats.passed_percent+'%'}} </h3>
        </v-col>
        <v-col cols="12"><v-divider></v-divider></v-col>
      </v-row> 

 
      <template v-if="coursesdata.length >0">
      <v-row v-for="(courses, courseindex) of coursesdata" :key="courseindex">
        <v-col cols="12" sm="12" md="12" class="pt-0">
              <h3 class="mb-5">{{ courses.course_name }}</h3>
                   <v-card class="mb-2" v-if="isSearching ==false">
                      <v-tabs v-model="openedTab[courses.course_id]">
                      <v-tab href="#viewquiztab" v-if="has_quiz == true" @click="getQuizData(courseindex, null, null, courses.course_id)"> {{ 'Quiz' | translate}} </v-tab>
                      <v-tab href="#viewlmtab" @click="openDocumentPanel('search'+courses.course_id,courses.course_id)"> {{ 'Learning material' | translate }} </v-tab>
                    </v-tabs>
                      <v-tabs-items v-model="openedTab[courses.course_id]">
                      <v-tab-item value="viewquiztab" v-if="has_quiz == true">
                        <v-card flat>
                              <v-sheet
                                class="mx-auto"
                                v-if="(dashboardcoursequizzes.hasOwnProperty(courses.course_id) ? (dashboardcoursequizzes[courses.course_id].length >0 ? true : (loadingdata ==false ? true : false) ): false )"
                              >
                                <v-slide-group
                                  class="pa-n5"
                                  show-arrows
                                >
                                  <v-slide-item
                                    v-for="(coursequizdata,coursequizindex) of dashboardcoursequizzes[courses.course_id]" 
                                    :key="coursequizindex+''+coursequizdata.gendoc_id+''+coursequizdata.course_id"
                                  >
                                      <v-card
                                        class="ma-4 pa-1"
                                        max-width="250"
                                        width="250"
                                        outlined
                                      >
                                        <v-list-item>
                                          <v-row>
                                          <v-col cols="7" class="pa-1">
                                          <v-list-item-content>
                                            <div style="color: rgba(0, 0, 0, 0.6) !important;font-size: 0.875rem !important;">
                                              {{coursequizdata.quiz_name}}
                                            </div>
                                          </v-list-item-content>
                                          </v-col>

                                          <v-col cols="5" class="pa-1">
                                            <v-list-item-avatar
                                              tile
                                              size="80"
                                              color="grey"
                                            >
                                              <v-img
                                              v-if="coursequizdata.quiz_image"
                                              :src="storage_url + coursequizdata.quiz_image"
                                            ></v-img>
                                            </v-list-item-avatar>
                                          </v-col>
                                          </v-row>
                                        </v-list-item>

                                          <v-row>
                                            <v-col class="pb-1 pt-0">
                                              <v-card-actions>
                                              <v-btn
                                                width="220"
                                                class="white--text"
                                                :color="primary_color"
                                                small
                                                @click="callQuiz(coursequizdata.quiz_id)"
                                              >
                                                {{'Take Quiz'| translate}}
                                              </v-btn>
                                            </v-card-actions>
                                            </v-col>
                                          </v-row>

                                      
                                      </v-card>
                                  </v-slide-item>
                                </v-slide-group>
                              </v-sheet>
                              <v-card-text v-else>
                                {{'No Quiz to display for this course' | translate}}
                              </v-card-text>
                        </v-card>
                      </v-tab-item>

                      <v-tab-item value="viewlmtab" :active="true">
                        <v-card flat>
                            <v-card-text>
                              <v-sheet
                                class="mx-auto"
                                v-if="(dashboarddocuments.hasOwnProperty(courses.course_id) ? (dashboarddocuments[courses.course_id].length >0 ? true : (loadingdata ==false ? true : false) ): false )"
                              >
                                <v-slide-group
                                  class="pa-n5"
                                  show-arrows
                                >
                                  <v-slide-item
                                    v-for="(documentdata,documentindex) of dashboarddocuments[courses.course_id]" 
                                    :key="documentindex+''+documentdata.gendoc_id+''+documentdata.course_id"
                                  >

                                  <v-card
                                      class="ma-1 pa-0"
                                      max-width="210"
                                      outlined
                                      rel="noopener noreferrer" 
                                      target="_blank" 
                                      :to="'/learningmaterial/'+documentdata.hash_id"
                                    >
                                      <v-list-item>
                                        <v-list-item-content>
                                          <div class="text-overline mb-2" v-if="documentdata.gendoc_name.length <=20">
                                            <v-icon v-text="'mdi-file-document'"></v-icon>{{documentdata.gendoc_name}}
                                          </div>
                                          <div class="text-overline mb-2" v-else>
                                            <v-icon v-text="'mdi-file-document'"></v-icon>{{ documentdata.gendoc_name | readMore(20, '...') }}
                                          </div>
                                        </v-list-item-content>
                                      </v-list-item>
                                  </v-card>

                                  </v-slide-item>
                                </v-slide-group>
                              </v-sheet>
                            </v-card-text>
                        </v-card>

                      </v-tab-item>
                                  
                    </v-tabs-items>
                  </v-card>

              <v-expansion-panels  v-model="openedPanel[courseindex]" multiple accordion>
                <template v-for="(moduledata,moduleindex) of courses.company_modules">

                  <v-expansion-panel v-if="moduledata.is_subscribed" expandable :key="courseindex+''+moduleindex"   :value="moduleindex"  class="mb-5">
                  <v-expansion-panel-header class="pa-0 nonfocus">
                    <v-row>
                    
                      <v-col cols="3" md="2" class="pt-9 text-center username" v-if="moduledata.hasOwnProperty('user_name')" v-on:click.stop="getTime(courseindex,moduleindex,moduledata.module_id,courses.course_id, (moduledata.hasOwnProperty('user_id')? moduledata.user_id :''),'from'+( activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'attempt' : 'session'   ):'')+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''),'to'+( activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'attempt' : 'session'   ):'')+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''))">{{ moduledata.user_name }}</v-col>
                      <v-col cols="3" md="2" class="pt-9 text-center play-button" v-else v-on:click.stop="play(moduledata,moduledata.module_id)"> <v-btn class="white--text mt-n1 notification" :color="primary_color"><v-icon v-if="moduledata.show_module" color="#fff" class="mr-2">mdi-play-circle</v-icon><v-icon v-else color="#fff" class="mr-2">mdi-lock</v-icon>{{ 'Play' | translate }} <span class="badge" v-if="courses.has_sort" v-bind:style="{ 'border-color':primary_color ,'color':primary_color}" >{{moduledata.sort_sequence}}</span></v-btn></v-col>

                    <v-col cols="12" md="4" class="pt-11 module-title" v-on:click.stop="getTime(courseindex,moduleindex,moduledata.module_id,courses.course_id,moduledata.hasOwnProperty('user_id')? moduledata.user_id: '','from' +(activeData.hasOwnProperty(courses.course_id)? activeData[courses.course_id][moduleindex] == 'time'? 'attempt': 'session': '') +courses.course_id +moduledata.module_id +moduleindex +(moduledata.hasOwnProperty('user_id')? moduledata.user_id: ''),'to' +(activeData.hasOwnProperty(courses.course_id)? activeData[courses.course_id][moduleindex] == 'time'? 'attempt': 'session': '') +courses.course_id +moduledata.module_id +moduleindex +(moduledata.hasOwnProperty('user_id')? moduledata.user_id: ''))">{{ moduledata.title }}</v-col>
                        
                        <v-col cols="3" md="2" class="pt-9 text-center modulequiz"  v-if="moduledata.show_quiz&&has_quiz" v-on:click.stop="getQuizData(courseindex,moduleindex,moduledata.module_id,courses.course_id)"><v-btn class="white--text mt-n1" :color="primary_color"><v-icon color="#fff" class="mr-2">mdi-frequently-asked-questions</v-icon>{{ "Quiz" | translate }}</v-btn></v-col>
                        <v-col cols="3" md="2" class="pt-9 text-center modulequiz"  v-else></v-col>
                    
                    <v-col cols="3" md="2" class="pt-7 pb-7 text-center timespent" v-bind:style="{'background-color':'#f7f7f7'}" v-on:click.stop="getTime(courseindex,moduleindex,moduledata.module_id,courses.course_id,(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''),'from'+( activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'attempt' : 'session'   ):'')+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''), 'to'+( activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'attempt' : 'session'   ):'')+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''))"><h4 class="pb-2">{{ 'Time Spent' | translate }}</h4>{{ moduledata.time_spent }}</v-col>
                   
                    <v-col cols="3" md="2" class="pt-9 text-center progress" v-bind:style="{'background-color':primary_color}" v-on:click.stop="getLockerQuizData(courseindex,moduleindex,moduledata.module_id,courses.course_id,(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''),'from'+( activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'attempt' : 'session'   ):'')+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''),'to'+( activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'attempt' : 'session'   ):'')+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''))">
                      <h4 class="mt-n2 white--text">{{ 'Progress & Attempts' | translate }}</h4>
                      <v-progress-circular
                        :rotate="360"
                        :size="40"
                        :width="4"
                        class="mt-2"
                        :value="moduledata.module_progress"
                        color="white"
                        v-if="moduledata.is_passed == false"
                      >
                        {{ moduledata.module_progress+ '%' }}
                      </v-progress-circular>      
                      <v-icon
                        color="success"
                        size="35"
                        class="mt-2"
                        v-text="'mdi-checkbox-marked-circle'"
                        v-else
                      ></v-icon>              
                    </v-col>
                  </v-row>
                <template v-slot:actions>
                    <v-icon class="pb-10 pt-10 pl-4 pr-4" v-on:click.stop="closePanel(courseindex,moduleindex,moduledata.module_id,courses.course_id,(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''))">$expand</v-icon>
                </template>
                </v-expansion-panel-header>
                
                <v-expansion-panel-content 
                v-bind:style=" 
                ( activeData.hasOwnProperty(courses.course_id) ? 
                (activeData[courses.course_id][moduleindex] == 'quiz' ? 
                 {'border':'4px solid '+primary_color} : 
                  {'background-color':'#f7f7f7'}):
                 '')      " >
                 
                 <v-row v-if="timesessiondata.hasOwnProperty(courses.course_id) && (activeData[courses.course_id][moduleindex] != 'modulequiz') " class="pt-4 mb-n4">
                    <v-col cols="12" md="2" class="text-center">
                      <h3 class="mt-3">{{ ( activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'Your sessions'  : 'Your attempts'  ):'') | translate }}</h3>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-menu
                        ref="menu"
                        v-model="menu['from'+( activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''  )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :'')]"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                        bottom
                        
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            :label="'From' | translate"
                            name="from"
                            :value="curLanguage.lang_code=='de'? toGerman(date['from'+(activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''   )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :'')]) :date['from'+(activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''   )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :'')]"
                            @input="saveChangedDate('from'+(activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''   )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''))"
                            prepend-icon="mdi-calendar"
                            :ref="'from'+(activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''   )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :'')"
                            autocomplete="off"
                            outlined
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="date['from'+(activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''   )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :'')]"
                          no-title
                          scrollable
                          :locale="curLanguage.lang_code"
                          :max="date['to'+(activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''   )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :'')]"
                          @input="menu['from'+(activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''   )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :'')] = false"
                        >
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-menu
                        ref="menuto"
                        v-model="menu['to'+(activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''   )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :'')]"
                        :close-on-content-click="true"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                        
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            :label="'To' | translate"
                            :ref="'to'+(activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''   )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :'')"
                            prepend-icon="mdi-calendar"
                            :value="curLanguage.lang_code=='de'? toGerman(date['to'+(activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''   )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :'')]) :date['to'+(activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''   )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :'')]"
                            @input="saveChangedDate('to'+(activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''   )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''))"
                            autocomplete="off"
                            outlined
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="date['to'+(activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''  )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :'')]"
                          no-title
                          scrollable
                          :min="date['from'+(activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''   )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :'')]"
                          :locale="curLanguage.lang_code"
                          @input="menu['to'+(activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''   )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :'')] = false"
                        >
                        </v-date-picker>
                      </v-menu>

                    </v-col>  
                    <v-col cols="12" md="3" >
                        <v-btn class="mt-2  white--text"  :color="primary_color" @click="( activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ?getTime(courseindex,moduleindex,moduledata.module_id,courses.course_id,(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''),'from'+(activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''   )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''),'to'+(activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''   )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :'')): getLockerQuizData(courseindex,moduleindex,moduledata.module_id,courses.course_id,(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''),'from'+(activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''   )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''),'to'+(activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''   )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''))):'')" >{{ 'Check' | translate}}</v-btn>
                        <v-btn class="mt-2 white--text"  :color="primary_color"  @click="( activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ?clearTime(courseindex,moduleindex,moduledata.module_id,courses.course_id,(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''),'from'+(activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''   )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''),'to'+(activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''   )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :'')): clearQuizData(courseindex,moduleindex,moduledata.module_id,courses.course_id,(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''),'from'+(activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''  )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''),'to'+(activeData.hasOwnProperty(courses.course_id)  ? (activeData[courses.course_id][moduleindex] == 'time' ? 'session'  : 'attempt'): ''   )+courses.course_id+moduledata.module_id+moduleindex+(moduledata.hasOwnProperty('user_id')? moduledata.user_id :''))):'')">{{ 'Clear' | translate}}</v-btn>
                    </v-col>                     
                    <v-col cols="12" md="1" >
                    </v-col>                                      
                  </v-row> 
                  
                  <v-sheet
                    class="mx-auto"
                    style="'background-color':'#f7f7f7'"
                    v-if="(timesessiondata.hasOwnProperty(courses.course_id) ==true ?   timesessiondata[courses.course_id].hasOwnProperty(moduleindex) ==true ? timesessiondata[courses.course_id][moduleindex].length > 0  ? true : false : false : false )"
                  >
                    <v-slide-group
                      class="pa-4"
                      show-arrows
                      v-bind:style=" 
                      ( activeData.hasOwnProperty(courses.course_id) ? 
                      (activeData[courses.course_id][moduleindex] == 'time' ?
                        {'background-color':'#f7f7f7'}:'')||(activeData[courses.course_id][moduleindex] == 'modulequiz' ?
                        {'background-color':'#f7f7f7'}:''): 
                      '')      "

                    >
                      <v-slide-item
                        v-for="(time,timeindex) of timesessiondata[courses.course_id][moduleindex]"
                        :key="timeindex"
                      >
                        <v-card
                          class="ma-4 pa-2"
                          width="220"
                          v-if="time.hasOwnProperty('statement_query') == true"
                        >
                        <v-row
                          align="center"
                          justify="center"
                        >
                            <v-icon
                              color="success"
                              size="60"
                              class="pb-2"
                              v-text="'mdi-checkbox-marked-circle'"
                              v-if="time.statement_query == 'passed'"
                            ></v-icon>
                            <v-icon
                              color="yellow darken-1"
                              size="60"
                              class="pb-2"
                              v-text="'mdi-book'"
                              v-else-if="time.statement_query == 'attempted'"
                            ></v-icon>
                            <v-icon
                              color="red accent-3"
                              size="60"
                              class="pb-2"
                              v-text="'mdi-exclamation'"
                              v-else
                            ></v-icon>

                        </v-row>
                        <v-card-title>{{ time.statement_query | translate }}</v-card-title>
                        <v-card-text>
                          {{ 'Attempted on' | translate }}{{ ': '+(curLanguage.lang_code == 'de' ? moment(time.stored_at).format('DD.MM.YYYY hh:mm:ss') : time.stored_at )}}
                        </v-card-text>
                          <v-card-actions class="justify-center">
                              <v-btn class="white--text" :color="primary_color" small @click="details(courses.course_id, moduleindex, timeindex, time.statement_query)">{{ 'Details new' | translate}}</v-btn>
                          </v-card-actions>                          
                        </v-card>


                        <v-card
                        class="ma-4 pa-2"
                        max-width="250"
                        width="250"
                        outlined
                        v-else-if="time.hasOwnProperty('quiz_type') ? (time.quiz_type=='module') ? true : false : false"
                        >
                        <v-list-item>
                            <v-row>
                            <v-col cols="7" class="pa-1">
                            <v-list-item-content>
                            <div style="color: rgba(0, 0, 0, 0.6) !important;font-size: 0.875rem !important;">
                                {{time.quiz_name}}
                            </div>
                            </v-list-item-content>
                            </v-col>

                            <v-col cols="5" class="pa-1">
                            <v-list-item-avatar
                                tile
                                size="80"
                                color="grey"
                            >
                                <v-img
                                v-if="time.quiz_image"
                                :src="storage_url + time.quiz_image"
                            ></v-img>
                            </v-list-item-avatar>
                            </v-col>
                            </v-row>
                        </v-list-item>

                            <v-row>
                            <v-col class="pb-1 pt-0">
                                <v-card-actions>
                                <v-btn
                                width="220"
                                class="white--text"
                                :color="primary_color"
                                small
                                @click="callQuiz(time.quiz_id)"
                                >
                                {{'Take Quiz'| translate}}
                                </v-btn>
                            </v-card-actions>
                            </v-col>
                            </v-row>

                        
                        </v-card>

                        <v-card
                          class="ma-4 pa-2"
                          width="220"
                          v-else
                        >
                        <v-card-title>{{ time.session_length}}</v-card-title>
                        <v-card-text>
                          <v-row>
                          <v-col cols="6">
                            {{ 'From' | translate }}<br />
                            {{ curLanguage.lang_code == 'de' ? moment(time.start_time).format('DD.MM.YYYY hh:mm:ss') : time.start_time }}
                          </v-col>
                          <v-col cols="6">
                            {{ 'To' | translate }}<br />
                            {{ curLanguage.lang_code == 'de' ? moment(time.end_time).format('DD.MM.YYYY hh:mm:ss')  : time.end_time }}
                          </v-col>
                          </v-row>
                        </v-card-text>
                        </v-card>

                      </v-slide-item>
                    </v-slide-group>
                  </v-sheet>
                    
                  <h3 v-else-if="loadingdata == false &&routerenter ==false">{{ 'No data found' | translate }}</h3>
                
                </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel v-else-if="moduledata.is_subscribed==false" :key="courseindex+''+moduleindex"   :value="moduleindex"  class="mb-5">
                  <v-expansion-panel-header class="pa-0 nonfocus">
                    <v-row>
                      <v-col cols="4" md="2" class="pt-10 pb-6 text-center username " v-if="moduledata.hasOwnProperty('user_name')">{{ moduledata.user_name }}</v-col>
                      <v-col cols="12" md="6" class="pt-6 pb-7 mt-4 module-title ">{{ moduledata.title }}</v-col>
                      <v-col cols="4" md="2" class="pt-6 pb-7 text-center"></v-col>
                      <v-col cols="3" md="2" class="pt-6 pb-7 text-center "><v-chip class="ma-2 ml-n6" style="color:white;" :color="primary_color">{{ 'Not subscribed' | translate }}</v-chip></v-col>
                    </v-row>
                <template v-slot:actions>
                    <v-icon class="pb-10 pt-10 pl-4 pr-4">{{ '' }}</v-icon>
                </template>

                  </v-expansion-panel-header>
                </v-expansion-panel>
                </template>
              </v-expansion-panels>
        </v-col>
      </v-row>
      </template>
      <template v-else-if="coursesdata.length == 0  && loadingdata==false && routerenter ==false ">
          <v-row align="center"
              justify="center">
              <v-col>
                <h2 v-if="(selectedCourses.length > 0  || selectedUsers.length > 0 || selectedGroups.length > 0) &&  (this.currentUser.roles.includes(1) || this.currentUser.roles.includes(3))">{{  'No subscribed courses found'  | translate }}</h2>
                <h2 v-else>
                  {{'Please subscribe to a course' | translate}} 
                  <v-btn small :color="primary_color" @click="goToCourse()" class="white--text" >
                    {{'Go to courses' | translate}}
                  </v-btn>
                </h2>
              </v-col>
          </v-row>
      </template>
      
      </template>
    </v-container>
    <v-dialog v-model="dialog" max-width="800">
      <v-card>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <DataTable
                :title="quizdetailtitle"
                :headers="quizdetailheaders"
                :items="quizdetaildata"
                :search="quizdetailsearch"
                :footerstatus='footerstatus'
              />
            </v-col>
          </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="primary darken-1" text @click="dialog = false">{{ 'Close'| translate }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

     <v-dialog v-if="!loadingdata" v-model="moduleQuizDialog" persistent>
      <v-card v-if="questions.length > 0" class="quiz-container">
        <v-stepper v-model="stage">
          <v-stepper-header>
            <v-stepper-step :complete="stage > 1" step="1">
              {{ "Instructions" | translate }}
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="stage > 2" step="2">
              {{ "Quiz" | translate }}
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step step="3">
              {{ "Results" | translate }}
            </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items v-bind:style="{ 'background-color': '#f7f7f7' }">
            <v-stepper-content step="1">
              <v-card
                class="mx-auto"
                max-width="800"
                style="min-height: 400px; overflow-y: scroll"
              >
                <v-row class="ma-3">
                  <v-col cols="12">
                    <v-row>
                      <v-col cols="12" md="9" sm="12">
                        <v-card-title
                          class="text-h5"
                          v-text="moduleQuiz.quiz_name"
                        ></v-card-title>
                        <v-card-subtitle
                          v-text="moduleQuiz.quiz_description"
                        ></v-card-subtitle>
                      </v-col>
                      <v-col cols="12" md="3" sm="12">
                        <v-avatar class="grey" size="125" tile>
                          <v-img
                            v-if="moduleQuiz.quiz_image"
                            :src="storage_url + moduleQuiz.quiz_image"
                          ></v-img>
                        </v-avatar>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row class="ma-3">
                  <v-col>
                    <div>
                      <v-card-subtitle class="mb-n3">{{"Quiz Instruction 1"| translate}}</v-card-subtitle>
                      <v-card-subtitle class="mb-n3">{{"Quiz Instruction 2"| translate}}</v-card-subtitle>
                      <v-card-subtitle class="mb-n3">{{"Quiz Instruction 3"| translate}}</v-card-subtitle>
                      <v-card-subtitle class="mb-n3">{{"Quiz Instruction 4"| translate}}</v-card-subtitle>
                      <v-card-subtitle class="mb-n3">{{"Quiz Instruction 5"| translate }}{{ moduleQuiz.passing_percentage }}%</v-card-subtitle>
                    </div>
                  </v-col>
                </v-row>

                <v-row class="ma-3" v-if="extquizdetaildata.length">
                  <v-col cols="12">
                    <div>
                      <v-divider></v-divider>
                      <DataTable
                        :title="extquizdetailtitle"
                        :headers="extquizdetailheaders"
                        :items="extquizdetaildata"
                        :footerstatus='footerstatus'
                      />
                    </div>
                  </v-col>
                </v-row>
              </v-card>

              <v-card
                class="mx-auto mt-2"
                max-width="800"
                v-bind:style="{ 'background-color': '#f7f7f7' }"
                elevation="0"
              >
                <v-btn
                  class="white--text mt-n1"
                  :color="primary_color"
                  @click="startStage2"
                >
                  {{ "Start" | translate }}</v-btn
                >

                <v-btn text @click="moduleQuizDialog = false">
                  {{ "Close" | translate }}
                </v-btn>
              </v-card>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-card
                class="mx-auto pa-5"
                max-width="800"
                style="min-height: 400px; overflow-y: scroll"
              >
                <v-form ref="form">
                  <v-row
                    class="no-gutters"
                    v-for="(question, questionindex) of questions"
                    :key="questionindex"
                  >
                    <v-col>
                        <v-card-title style="word-break: break-word">{{
                          question.question_text
                        }}</v-card-title>
                        <v-card-subtitle>{{
                          question.question_help_text
                        }}</v-card-subtitle>

                        <v-card-text class="pb-0"
                          v-if="question.question_type == 'single-select'"
                        >
                          <v-row class="no-gutters">
                            <v-col cols="12">
                              <v-radio-group class="mt-n4"
                                v-model="
                                  questionAnswers[questionindex].answer_id
                                "
                                  @change="checkifAnswered()"
                              >
                                <v-radio
                                  v-for="(
                                    answer, answerindex
                                  ) of question.answers"
                                  :key="answerindex"
                                  :value="answer.answer_id"
                                  :label="`${answer.answer_text}`"
                                ></v-radio>
                              </v-radio-group>
                            </v-col>
                          </v-row>
                        </v-card-text>
                        <v-card-text class="pb-0" v-else>
                          <v-row class="no-gutters">
                            <v-col cols="12">
                              <v-checkbox class="mt-n4"
                                v-model="
                                  questionAnswers[questionindex].answer_id
                                "
                                v-for="(
                                  answer, answerindex
                                ) of question.answers"
                                :key="answerindex"
                                :value="answer.answer_id"
                                :label="`${answer.answer_text}`"
                                @change="checkifAnswered()"
                              >
                              </v-checkbox>
                            </v-col>
                          </v-row>
                        </v-card-text>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card>

              <v-card
                class="mx-auto mt-2"
                max-width="800"
                v-bind:style="{ 'background-color': '#f7f7f7' }"
                elevation="0"
              >
                <v-btn
                  class="white--text mt-n1"
                  :color="primary_color"
                  @click="submitAnswers"
                  :disabled="!answeredAllQuestions"
                >
                  {{ "Submit" | translate }}
                </v-btn>

                <v-btn
                  text
                  @click="
                    moduleQuizDialog = false;
                    stage = 1;
                  "
                >
                  {{ "Quit" | translate }}
                </v-btn>
              </v-card>
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-card
                class="mx-auto"
                max-width="800"
                style="min-height: 400px; overflow-y: scroll"
              >
                <v-card
                  class="mx-auto result-box"
                  max-width="530"
                  elevation="0"
                >
                  <v-row>
                    <v-col>
                      <div>
                        <h2 class="text-center text-uppercase">
                          {{ "Result" | translate }}
                        </h2>
                        <v-card-text
                          class="text-center text-uppercase"
                          style="font-size: 20px"
                          v-if="quizResults.is_passed"
                        >
                          <v-icon large color="green darken-2"
                            >mdi-checkbox-marked-circle</v-icon
                          >
                          {{ "passed" | translate }}</v-card-text
                        >
                        <v-card-text
                          class="text-center text-uppercase"
                          style="font-size: 20px"
                          v-else
                        >
                          <v-icon large color="orange darken-2"
                            >mdi-alert-circle-outline</v-icon
                          >
                          {{ "failed" | translate }}</v-card-text
                        >
                        <v-row class="result-percentage">
                          <v-col cols="12" md="6" sm="12">
                            <v-card-text class="text-center">{{ "You scored" | translate }} {{ quizResults.scored_percentage }}%</v-card-text>
                          </v-col>
                          <v-col cols="12" md="6" sm="12">
                            <v-card-text class="text-center">{{ "Percent of passing is" | translate }} {{ quizResults.passing_percentage }}%</v-card-text>
                          </v-col>
                        </v-row>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-card>

              <v-card
                class="mx-auto mt-2"
                max-width="800"
                v-bind:style="{ 'background-color': '#f7f7f7' }"
                elevation="0"
              >
                <v-btn
                  class="white--text mt-n1"
                  :color="primary_color"
                  @click="restartQuiz(moduleQuiz.quiz_id)"
                >
                  {{ "Take Quiz Again" | translate }}
                </v-btn>

                <v-btn
                  text
                  @click="
                    moduleQuizDialog = false;
                    stage = 1;
                  "
                >
                  {{ "Close" | translate }}
                </v-btn>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
      <v-card v-else>
        <v-card-title>
          {{ "There are no Quiz to show" | translate }}
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            text
            @click="moduleQuizDialog = false"
            >{{ "Close" | translate }}</v-btn
          ></v-card-title
        >
      </v-card>
    </v-dialog>

    <v-dialog v-model="lockMessage" persistent max-width="560">
      <v-card>
        <v-card-title class="headline">{{ "You need to complete previous modules"| translate }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" text @click="lockMessage = false">{{ 'Close'| translate }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="isLoading">
      <v-layout row justify-center v-if="isLoading">
        <v-dialog v-model="loadingdata" persistent fullscreen content-class="loading-dialog">
          <v-container fill-height>
            <v-layout row justify-center align-center>
              <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
            </v-layout>
          </v-container>
        </v-dialog>
      </v-layout>
    </v-overlay>

  </v-content>
</template>

<script>
import { mapGetters } from "vuex";
import moment from 'moment'
import store from "@/store";
import {
  FETCH_DASHBOARD_DATA,
  FETCH_DASHBOARD_DOCUMENTS,
  FETCH_DASHBOARD_QUIZ_DATA,
  FETCH_TIME_DATA,
  FETCH_COURSES,
  FETCH_USERS,
  FETCH_GROUPS,
  FETCH_DASHBOARD_STATS_DATA,
  FETCH_DASHBOARD_COURSE_QUIZ_DATA,
  FETCH_DASHBOARD_MODULE_QUIZ_DATA,
  FETCH_INDIVIDUAL_QUIZ,
  FETCH_QUESTION,
  ADD_USER_ANSWERS,
  FETCH_DASHBOARD_QUIZ_HISTORY_DATA,
  RESET_STATE
} from "@/store/actions.type";
import { RESET_COURSES_DATA,SET_LOADING, SET_ROUTER_ENTER } from "@/store/mutations.type";

export default {
  name: "Dashboard",
  beforeRouteEnter(to, from, next) {
      store.dispatch(RESET_STATE)
    if (store.state.auth.user.roles.includes(1) || store.state.auth.user.roles.includes(3)) {
      Promise.all([
        store.dispatch(FETCH_GROUPS, ""),
        store.dispatch(FETCH_COURSES, ''),
        store.dispatch(FETCH_USERS, "")

      ]).finally(()=>{
          store.commit(SET_LOADING, false)
                  
      })
    }
    return next();
  },
  components: {
    DataTable: () => import("@/components/datatable/datatable"),
    Header: () => import("@/components/header/Header"),
    Tutor: () => import("@/components/modal/Tutor"),
  },  
  computed: {
    ...mapGetters(["coursesdata",'dashboardstats',"timesessiondata","dashboarddocuments","dashboardcoursequizzes", "users", "courses","currentUser","loadingdata",'routerenter','curLanguage','loggedin','groups','videotutorialdata']),    
    extquizdetailheaders () {
      return [
            {text: this.$t("Your score"), value:'result.score.raw'},
            {text: this.$t("Max Score"), value:'result.score.max'},
            {text: this.$t("Time taken"), value:'result.seconds'},
            {text: this.$t("Result"), value:'statement_query'},
      ]
    },
    computeCurrentTab(val){
        if(val){
            return this.quiz_tab
        }
        return this.lm_tab
    }
  },
  created() {
    this.storage_url = process.env.VUE_APP_COMPANYADMIN_STORAGE_URL;
  },
  async mounted(){
    let company_meta  = JSON.parse(this.currentUser.company.company_meta)
    if(company_meta.hasOwnProperty('has_quiz')){
      this.has_quiz = (company_meta.has_quiz==='true') //since returned value is a tring and not boolean
    }
    if(company_meta.hasOwnProperty('has_tutor_products')){
      this.has_tutor_products = (company_meta.has_tutor_products==='true')
    }
    await this.getDashboardData();
    this.primary_color  = company_meta.primary_color

    //After dom elements are mounted we can set the correct tabs to be opened
    this.coursesdata.forEach((element) => {
        if(this.has_quiz==true){
          if(this.dashboardcoursequizzes.hasOwnProperty(element.course_id) ? (this.dashboardcoursequizzes[element.course_id].length >0 ? true : false ): false ){
              this.openedTab[element.course_id] = 'viewquiztab'
          }
        }
        else{
            // Fetch learning material
            this.openDocumentPanel('search'+element.course_id,element.course_id)
            this.openedTab[element.course_id] = 'viewlmtab'
        }
    });
  },
  data: function() {
   return {
      date: [],
      menu: [],
      moment:moment,
      openedDocumentPanel:[],
      openedPanel: {},
      selectedUsers: [],
      selectedCourses: [],
      selectedGroups: [],
      primary_color: '',
      activeData:{},
      quizdetailsearch: "",
      footerstatus: 'false',
      quizdetailheaders: [],
      quizdetailtitle: 'Module details',
      dialog: false,   
      quizdetaildata: [], 
      isSearching: false,
      adminSearch: false,
      ischangeGroupApi: false,
      checkAllGroups: false,
      checkAllCourses: false,
      checkAllUsers: false,
      moduleQuizDialog: false,
      storage_url: "",
      stage: 1,
      moduleQuiz: [],
      questions: [],
      questionAnswers: [],
      quizResults: [],
      answeredAllQuestions: false,
      has_quiz:false,
      has_tutor_products:false,
      tabs:null,
      startTime:null,
      endTime:null,
      isLoading:false,
      openedTab:[],
      extquizdetaildata: [], 
      extquizdetailtitle: 'Quiz Score History',
      lockMessage:false,
    };
  },
  methods: {
    async clearFilter(){
      this.checkAllGroups = false
      this.checkAllCourses = false
      this.checkAllUsers = false      
      this.selectedGroups = []
      this.selectedCourses = []
      this.selectedUsers = []
      await this.changedGroup()
      await this.getDashboardData()
    },
    checkboxUpdated(flag){
      if(flag == "groups" && this.checkAllGroups){
          this.selectedGroups = []
          this.selectedGroups = this.groups.map(data=>data.group_id)
          this.selectedUsers = []
          this.selectedCourses = []
          this.checkAllCourses = false
          this.checkAllUsers = false   
          this.changedGroup()
      }
      else if(flag=="groups" && this.checkAllGroups == false){
        this.selectedGroups = []
        this.selectedUsers = []
        this.selectedCourses = []
        this.checkAllCourses = false
        this.checkAllUsers = false   
        this.changedGroup()
      }
      else if(flag== "courses" && this.checkAllCourses){
        this.selectedCourses = []
        this.selectedCourses = this.courses.map(data=>data.course_id)
      }
      else if(flag== "courses" && this.checkAllCourses == false){
        this.selectedCourses = []
      }
      else if(flag == "users" && this.checkAllUsers){
        this.selectedUsers = []
        this.selectedUsers = this.users.map(data=>data.user_id)        
      }
      else if(flag== "users" && this.checkAllUsers == false){
        this.selectedUsers = []
      }

    },
    async changedGroup(){
      this.ischangeGroupApi = true
      await this.$store.dispatch(FETCH_COURSES,'?group_ids='+this.selectedGroups)
      await this.$store.dispatch(FETCH_USERS,'?group_ids='+this.selectedGroups)
      this.$store.commit(SET_LOADING, false)
      this.ischangeGroupApi = false
    },
    goToCourse(){
      this.$router.push('/courses')
    },
    toGerman(datevalue){
      if((typeof datevalue !== 'undefined') && (datevalue !== null)){
        let [year, month, day] = datevalue.split('-')
        return [day,month,year].join('.')
      }
      else{
        return ''
      }
    },
    saveChangedDate(idkey){
      if(this.curLanguage.lang_code == 'en'){  
          this.date[idkey]=this.$refs[idkey][0].internalValue  
      }
      else{
        if(typeof this.$refs[idkey][0].internalValue !== 'undefined' && this.$refs[idkey][0].internalValue !== null){
          let [day,month,year] = this.$refs[idkey][0].internalValue.split('.')
          if(isNaN(Date.parse(year+'-'+month+'-'+day))== false){
            this.date[idkey]=year+'-'+month+'-'+day
          }
        }
      }
    },
    async clearTime(courseindex,moduleindex,moduleid, course_id, userid,from,to){

      (this.$refs[from] != undefined ? (this.date[from] =null,this.$refs[from][0].internalValue =null): null);
      (this.$refs[to] != undefined ? (this.date[to]=null,this.$refs[to][0].internalValue =null): null);

      this.getTime(courseindex,moduleindex,moduleid, course_id, userid,from,to)
    },
    async clearQuizData(courseindex,moduleindex,moduleid, course_id, userid,from,to){
      (this.$refs[from] != undefined ? (this.date[from] = null, this.$refs[from][0].internalValue =null): null);
      (this.$refs[to] != undefined ? (this.date[to]= null, this.$refs[to][0].internalValue =null): null);
    
      this.getLockerQuizData(courseindex,moduleindex,moduleid, course_id, userid,from,to)
    },
    async getQuizData(courseindex, moduleindex, moduleid, course_id) {
      if(moduleindex==null){
        let params = {'course_id':course_id}
        await this.$store.dispatch(FETCH_DASHBOARD_COURSE_QUIZ_DATA, params).then(() => {
          this.$store.commit(SET_LOADING, false);
        });
      }
      else{
        await store.commit(SET_LOADING, true);
        if (this.activeData.hasOwnProperty(course_id) == false) {
          this.activeData[course_id] = {};
        }
        this.activeData[course_id][moduleindex] = "modulequiz";
        await this.$store.dispatch(FETCH_DASHBOARD_MODULE_QUIZ_DATA, {moduleid: moduleid, moduleindex:moduleindex, course_id:course_id}).then(() => {
          this.$store.commit(SET_LOADING, false);
          this.openPanel(courseindex, moduleindex);
        });
      }
    },
    async startStage2(){
      this.startTime = new Date();
      this.stage = 2
    },
    async restartQuiz(quiz_id){
      this.stage = 1
      this.callQuiz(quiz_id)
    },
    async callQuiz(quizId) {
      this.isLoading = true;
      await store.commit(SET_LOADING, true);
      await store.dispatch(FETCH_INDIVIDUAL_QUIZ, quizId).then((resp1) => {
        if (resp1.success) {
          this.moduleQuiz = resp1.data;
          this.extquizdetaildata=[];
          this.fetchQuizHistory(this.moduleQuiz.quiz_type, this.moduleQuiz.quiz_type=='course'?this.moduleQuiz.course_id:this.moduleQuiz.modules[0],quizId)
        }
      });
      await store
        .dispatch(FETCH_QUESTION, "?quiz_id=" + quizId)
        .then((resp) => {
          if (resp.success) {
            store.commit(SET_LOADING, false);
            store.commit(SET_ROUTER_ENTER, false);
            //call quiz modal
            this.questions = resp.data;
            this.moduleQuizDialog = true;
            this.questionAnswers = [];
            this.answeredAllQuestions = false
            this.questions.forEach((element) => {
              this.questionAnswers.push({
                question_id: element.question_id,
                answer_id: [],
              });
            });
            this.isLoading = false;
          }
        });
        
    },
    fetchQuizHistory(type,id,quizId){
      this.getLockerExtQuizData(type,id,quizId)
    },
    checkifAnswered(){
        const withNull = this.questionAnswers.filter(v => v.answer_id=="");  
        if(withNull.length==0){
            this.answeredAllQuestions = true
        }
        else{
            this.answeredAllQuestions = false
        }
    },
    async submitAnswers() {
      this.endTime = new Date();
      var seconds = (this.endTime - this.startTime) / 1000;
      let params={
        quiz_id:this.moduleQuiz.quiz_id,
        "seconds":seconds,
        "question_answer":this.questionAnswers
      }
      if(this.moduleQuiz.quiz_type=="module"){
        params['module_id']= this.moduleQuiz.modules[0]
      }
      else{
        params['course_id']= this.moduleQuiz.course_id
      }

      await store
        .dispatch(ADD_USER_ANSWERS, params )
        .then((resp) => {
          if (resp != undefined && resp.success) {
            this.quizResults = resp.data;
            this.stage = 3
            this.$store.commit(SET_LOADING, false)
            this.moduleQuizDialog = true;
          } else {
            this.callQuiz(this.moduleQuiz.quiz_id);
          }
        });

      return;
    },
    async getTime(courseindex,moduleindex,moduleid, course_id, userid,from,to){
      await store.commit(SET_LOADING, true)
      if(this.activeData.hasOwnProperty(course_id) == false){
        this.activeData[course_id] = {}
      }
      this.activeData[course_id][moduleindex] = 'time'      

      await this.$store.dispatch(FETCH_TIME_DATA,{moduleid: moduleid, moduleindex:moduleindex, course_id:course_id, userid:userid, fromdate: (this.date[from] == undefined ? '':  this.date[from]  ), todate: (this.date[to] == undefined ? '' :this.date[to] )}).then(()=>{
        this.$store.commit(SET_LOADING, false)
        this.openPanel(courseindex,moduleindex)
      })
    },
    details(courseid,moduleindex,index, query) {
        if(query == 'attempted'){
          this.quizdetailheaders= [
            {text: this.$t("Your score"), value:'result.score.raw'},
            {text: this.$t("Max Score"), value:'result.score.max'},
            {text: this.$t("Time taken"), value:'result.seconds'},
            {text: this.$t("Pass Score"), value:'pass_score'},
          ]  
        }
        else{
          this.quizdetailheaders= [
            {text: this.$t("Your score"), value:'result.score.raw'},
            {text: this.$t("Max Score"), value:'result.score.max'},
            {text: this.$t("Time taken"), value:'result.seconds'},
            {text: this.$t("Status"), value:'statement_query'},
          ]   
        }
        this.quizdetaildata = [this.timesessiondata[courseid][moduleindex][index]]
        this.dialog = true
    },
    async getLockerQuizData(courseindex,moduleindex,moduleid, course_id,userid,from,to){
      await store.commit(SET_LOADING, true)
      if(this.activeData.hasOwnProperty(course_id) == false){
        this.activeData[course_id] = {}
      }      
      this.activeData[course_id][moduleindex] = 'quiz'      
      await this.$store.dispatch(FETCH_DASHBOARD_QUIZ_DATA,{moduleid: moduleid, moduleindex:moduleindex, course_id:course_id, userid:userid, fromdate: (this.date[from] == undefined ? '':  this.date[from]  ), todate: (this.date[to] == undefined ? '' :this.date[to] )}).then(()=>{
        this.$store.commit(SET_LOADING, false)
        this.openPanel(courseindex,moduleindex)
      })
    }, 
    async getLockerExtQuizData(type,id,quizId){
      await store.commit(SET_LOADING, true)
      await this.$store.dispatch(FETCH_DASHBOARD_QUIZ_HISTORY_DATA,{moduleid: type=="module"?id:null,courseid: type=="module"?null:id,quiz_id:quizId}).then((resp)=>{
        this.extquizdetaildata = resp.data
        this.$store.commit(SET_LOADING, false)
        this.isLoading = false;
      })
    },    
    async getDashboardData(){
      await this.$store.commit(RESET_COURSES_DATA)
      this.openedDocumentPanel=[]
      this.openedPanel = {}
      this.activeData = {}


      if(this.currentUser.roles.includes(1) || this.currentUser.roles.includes(3)){
        let selectedusers = []
        let selectedcourses = []

        if(this.selectedGroups.length ==0 && this.selectedUsers == 0 && this.selectedCourses == 0){
          selectedcourses = []
          selectedusers = []
        }
        else{
          if(this.selectedUsers.length == 0){
            selectedusers = this.users.map(data=>data.user_id)
          }
          else{
            selectedusers = this.selectedUsers
          }

          if(this.selectedCourses.length == 0){
            selectedcourses =this.courses.map(data=>data.course_id)
          }
          else{
            selectedcourses = this.selectedCourses
          }
        }


        if(this.selectedUsers.length >0 || this.selectedGroups.length >0 || this.selectedCourses.length >0){
          this.isSearching = true
        }
        else{
          this.isSearching = false
        }

        this.adminSearch = true

        await Promise.all([
          await this.$store.dispatch(FETCH_DASHBOARD_DATA,'subscribed-courses?course_ids='+selectedcourses+'&user_ids='+selectedusers),
          (selectedcourses.length >0 || selectedusers.length >0 ?await this.$store.dispatch(FETCH_DASHBOARD_STATS_DATA,'show-statistics?course_ids='+selectedcourses+'&user_ids='+selectedusers): ''),
          ]).then(()=>{
          this.$store.commit(SET_LOADING, false)
          store.commit(SET_ROUTER_ENTER, false)
          let coursedatalength= this.coursesdata.length
          let i=0;
          while(i<coursedatalength){
            this.$set(this.openedPanel,i,[])
            i++;
          }
          this.adminSearch = false
          store.commit(SET_ROUTER_ENTER, false)
        })

      }
      else{
        await this.$store.dispatch(FETCH_DASHBOARD_DATA,'subscribed-courses').then(() => {
          this.$store.commit(SET_LOADING, false)
          store.commit(SET_ROUTER_ENTER, false)
          let coursedatalength= this.coursesdata.length
          let i=0;
          while(i<coursedatalength){
            this.$set(this.openedPanel,i,[])
            i++;
          }
          this.adminSearch = false
          store.commit(SET_ROUTER_ENTER, false)
        })
      }
      if(this.has_quiz==true){
        // fetch quiz for all courses if present
        await this.coursesdata.forEach((element) => {
          let params = {'course_id':element.course_id} // Not fetching module quizes when dashboard loads
          this.$store.dispatch(FETCH_DASHBOARD_COURSE_QUIZ_DATA, params).then((resp) => {
              this.$store.commit(SET_LOADING, false);
              if(resp.data.length){
                  this.openedTab[element.course_id]='viewquiztab'
              }
              else{
                  this.openedTab[element.course_id]='viewlmtab'
              }
          });
        });
      }
    },
    openPanel(courseindex,moduleindex){
      if(this.openedPanel[courseindex].indexOf(moduleindex) == -1){
        this.openedPanel[courseindex].push(moduleindex)
      }
    },
    async openDocumentPanel(searchvalue,courseid){
      let searchdata = (this.$refs[searchvalue] == undefined ? '': (this.$refs[searchvalue][0].internalValue == undefined ? '' :this.$refs[searchvalue][0].internalValue))
      await this.$store.dispatch(FETCH_DASHBOARD_DOCUMENTS,{course_id: courseid, search: searchdata}).then(() => {
        this.$store.commit(SET_LOADING, false)
        if(this.openedDocumentPanel.indexOf(courseid) == -1){
          this.openedDocumentPanel.push(courseid)
        }
      })    
    },
    closePanel(courseindex,moduleindex,moduleid,courseid,userid){
      if(this.openedPanel[courseindex].indexOf(moduleindex) >=0){
        this.openedPanel[courseindex] = this.openedPanel[courseindex].filter(item => item!=moduleindex)
      }
      else{
        this.openPanel(courseindex,moduleindex)
        this.clearTime(courseindex,moduleindex,moduleid, courseid, userid)
      }
    },
    play(moduledata,id) {
      if(!moduledata.show_module){
        this.lockMessage=true;
        // alert("You need to complete previous modules")
      }
      else{
        this.$router.push("/moduleplayer/" + id)
      }
    },
  }
};
</script>
<style scoped>
.result-percentage {
  border: 2px solid black;
  margin: auto;
  padding: 10px;
  text-align: center;
}
.result-box {
  margin: 40px;
}

.v-expansion-panel-header:before {
    background-color: #ffffff !important;
}

.nonfocus{
  background: #ffffff !important;
}

.nonfocus:focus{
  background: #ffffff !important;
}

.notification {
  text-decoration: none;
  padding: 15px 26px;
  position: relative;
  display: inline-block;
  border-radius: 2px;
}

.notification:hover {
  background: white;
}

.notification .badge {
  position: absolute;
  top: -13px;
  right: -24px;
  padding: 2px 5px;
  border-radius: 50%;
  background: white;
  border-style: solid;
  font-weight: bold;
}

@media (min-width: 300px) and (max-width: 960px) {
  .module-title{
    order:1;
  }
  .username{
    order:2;
  }
  .play-button{
    order:2;
  }
  .modulequiz{
    order:3;
  }
  .timespent{
    order:4;
  }
  .progress{
    order:5;
  }
}
</style>